// extracted by mini-css-extract-plugin
export var tooltip = "CardsAsDimensions-module--tooltip--c297a";